import { globals, page as pageIndex } from "../../globals";
import { logOut } from "./auth";
import { formatDate } from "./formatDate";
import { populateSortAndSearchParams } from "./helpers";
import { showModal } from "./modal";
import { actionHandler, UPDATE_DATA } from "./updateData";

// ------------------------------------
// Constants
// ------------------------------------
export const LEGIS_NRR_OPEN_RECORD_START = "LEGIS_NRR_OPEN_RECORD_START";
export const REFRESH_LEGIS_RECORDS = "REFRESH_LEGIS_RECORDS";
export const UPDATE_LEGIS_REVIEW_DATA = "UPDATE_LEGIS_REVIEW_DATA";
export const GET_LEGIS_QUERIES_LIST_START = "GET_LEGIS_QUERIES_LIST_START";
export const GET_LEGIS_NRR_QUERY_DATA_START = "GET_LEGIS_NRR_QUERY_DATA_START";
export const GET_LEGIS_NRR_QUERY_DATA_SUCCESS =
  "GET_LEGIS_NRR_QUERY_DATA_SUCCESS";
export const GET_LEGIS_NRR_QUERY_DATA_FAILURE =
  "GET_LEGIS_NRR_QUERY_DATA_FAILURE";
export const GET_LEGIS_TEAM_REVIEW_DATA_START =
  "GET_LEGIS_TEAM_REVIEW_DATA_START";
export const GET_LEGIS_TEAM_REVIEW_DATA_SUCCESS =
  "GET_LEGIS_TEAM_REVIEW_DATA_SUCCESS";
export const GET_LEGIS_TEAM_REVIEW_DATA_FAILURE =
  "GET_LEGIS_TEAM_REVIEW_DATA_FAILURE";
export const SET_LEGIS_TEAMS_REVIEW_DATA_START =
  "SET_LEGIS_TEAMS_REVIEW_DATA_START";
export const SET_LEGIS_TEAMS_REVIEW_DATA_SUCCESS =
  "SET_LEGIS_TEAMS_REVIEW_DATA_SUCCESS";
export const SET_LEGIS_TEAMS_REVIEW_DATA_FAILURE =
  "SET_LEGIS_TEAMS_REVIEW_DATA_FAILURE";
export const GET_LEGIS_TEAM_REVIEW_OPTIONS_DATA_START =
  "GET_LEGIS_TEAM_REVIEW_OPTIONS_DATA_START";
export const GET_LEGIS_TEAM_REVIEW_OPTIONS_DATA_SUCCESS =
  "GET_LEGIS_TEAM_REVIEW_OPTIONS_DATA_SUCCESS";
export const GET_LEGIS_TEAM_REVIEW_OPTIONS_DATA_FAILURE =
  "GET_LEGIS_TEAM_REVIEW_OPTIONS_DATA_FAILURE";
export const GET_LEGIS_RAWFILE_START = "GET_LEGIS_RAWFILE_START";
export const GET_LEGIS_RAWFILE_SUCCESS = "GET_LEGIS_RAWFILE_SUCCESS";
export const GET_LEGIS_RAWFILE_FAILURE = "GET_LEGIS_RAWFILE_FAILURE";
export const GET_LEGIS_KEYWORDS_START = "GET_LEGIS_KEYWORDS_START";
export const GET_LEGIS_KEYWORDS_SUCCESS = "GET_LEGIS_KEYWORDS_SUCCESS";
export const GET_LEGIS_KEYWORDS_FAILURE = "GET_LEGIS_KEYWORDS_FAILURE";
export const GET_LEGIS_CLIENT_SUBJECTS_START =
  "GET_LEGIS_CLIENT_SUBJECTS_START";
export const GET_LEGIS_CLIENT_SUBJECTS_SUCCESS =
  "GET_LEGIS_CLIENT_SUBJECTS_SUCCESS";
export const GET_LEGIS_CLIENT_SUBJECTS_FAILURE =
  "GET_LEGIS_CLIENT_SUBJECTS_FAILURE";
export const GET_LEGIS_LEGIS_TYPE_START = "GET_LEGIS_LEGIS_TYPE_START";
export const GET_LEGIS_LEGIS_TYPE_SUCCESS = "GET_LEGIS_LEGIS_TYPE_SUCCESS";
export const GET_LEGIS_LEGIS_TYPE_FAILURE = "GET_LEGIS_LEGIS_TYPE_FAILURE";
export const GET_LEGIS_LOAD_OPTIONS_START = "GET_LEGIS_LOAD_OPTIONS_START";
export const GET_LEGIS_LOAD_OPTIONS_FAILURE = "GET_LEGIS_LOAD_OPTIONS_FAILURE";
export const CLEAR_LEGIS_FIELD_FOR_NO_RESULTS =
  "CLEAR_LEGIS_FIELD_FOR_NO_RESULTS";
export const RETURN_LEGIS_RECORD_REVIEW_INITIAL_STATE =
  "RETURN_LEGIS_RECORD_REVIEW_INITIAL_STATE";
export const OPEN_LEGIS_RECORD_SUCCESS = "OPEN_LEGIS_RECORD_SUCCESS";
export const SET_LEGIS_ID_REVIEWED_START = "SET_LEGIS_ID_REVIEWED_START";
export const SET_LEGIS_ID_REVIEWED_FAILURE = "SET_LEGIS_ID_REVIEWED_FAILURE";
export const SET_LEGIS_ID_REVIEWED_SUCCESS = "SET_LEGIS_ID_REVIEWED_SUCCESS";
export const GET_LEGIS_HIGHLIGHTED_DOC_START =
  "GET_LEGIS_HIGHLIGHTED_DOC_START";
export const GET_LEGIS_HIGHLIGHTED_DOC_FAILURE =
  "GET_LEGIS_HIGHLIGHTED_DOC_FAILURE";
export const GET_LEGIS_HIGHLIGHTED_DOC_SUCCESS =
  "GET_LEGIS_HIGHLIGHTED_DOC_SUCCESS";
export const GET_LEGIS_INITIAL_DATA_START = "GET_LEGIS_INITIAL_DATA_START";
export const GET_LEGIS_INITIAL_DATA_COMPLETE =
  "GET_LEGIS_INITIAL_DATA_COMPLETE";
export const GET_QC_KEYWORD_MISSING_START = "GET_QC_KEYWORD_MISSING_START";
export const GET_QC_KEYWORD_MISSING_SUCCESS = "GET_QC_KEYWORD_MISSING_SUCCESS";
export const GET_QC_KEYWORD_MISSING_FAILURE = "GET_QC_KEYWORD_MISSING_FAILURE";
export const GET_QC_KEYWORD_REVIEW_START = "GET_QC_KEYWORD_REVIEW_START";
export const GET_QC_KEYWORD_REVIEW_SUCCESS = "GET_QC_KEYWORD_REVIEW_SUCCESS";
export const GET_QC_KEYWORD_REVIEW_FAILURE = "GET_QC_KEYWORD_REVIEW_FAILURE";
export const GET_LEGIS_SUBJECT_GROUP_LIST_START =
  "GET_LEGIS_SUBJECT_GROUP_LIST_START";
export const GET_LEGIS_SUBJECT_GROUP_LIST_FAILURE =
  "GET_LEGIS_SUBJECT_GROUP_LIST_FAILURE";
export const GET_LEGIS_SUBJECT_GROUP_LIST_SUCCESS =
  "GET_LEGIS_SUBJECT_GROUP_LIST_SUCCESS";
export const SET_QC_KEYWORD_REVIEW_START = "SET_QC_KEYWORD_REVIEW_START";
export const SET_QC_KEYWORD_REVIEW_FAILURE = "SET_QC_KEYWORD_REVIEW_FAILURE";
export const SET_QC_KEYWORD_REVIEW_SUCCESS = "SET_QC_KEYWORD_REVIEW_SUCCESS";
export const POST_RAW_FILE_LOAD_START = "POST_RAW_FILE_LOAD_START";
export const POST_RAW_FILE_LOAD_FAILURE = "POST_RAW_FILE_LOAD_FAILURE";
export const POST_RAW_FILE_LOAD_SUCCESS = "POST_RAW_FILE_LOAD_SUCCESS";

const headers = {
  "Content-Type": "application/json",
};

export function getLegisNRRInitialState() {
  return initialState;
}

function matchReviewRows(rows) {
  return rows.map((item) => {
    return {
      textValues: {
        team: item.Team || "",
        assignedBy: item.AssignedBy || "",
        assignedDate: formatDate(item.AssignedDate),
        reviewedBy: item.ReviewedBy || "",
        reviewedDate: formatDate(item.ReviewedDate),
        type: item.FlagTypeDesc,
        flag: String(item.FlagType),
      },
      isReviewed: item.ReviewedBy !== null,
    };
  });
}

function matchRecordInfo(info) {
  return {
    textValues: {
      id: info.RawFileId || "",
      legisId: info.LegisId,
      recordCreated: formatDate(info.FirstCheckedDate),
      checkedForUpdates: formatDate(info.LastCheckedDate),
      checkedForTextUpdates: formatDate(info.LegisCheckedDate),
      statusProcessingLastRun: formatDate(info.StatusDoneTime),
      summaryUpdated: formatDate(info.SummaryChangedDate),
      textDownloaded: formatDate(info.LegisDownloadedDate),
      textDownloadError: formatDate(info.LegisDownloadErrorTime),
      numberOfDownloadedTextFiles: info.LegisDownLoaded,
      sspath: info.ssLegisPath || "",
      state: info.State || "",
      billType: info.BillType || "",
      billNumber: info.BillNumber || "",
      session: info.Session || "",
      companion: info.Companion || "",
      sponsor: info.Sponsor || "",
      url: info.LegislationPath || "",
      summary: info.Summary || "",
      aisummary: info.AiSummary || "",
      history: info.History || "",
      toolboxUrl: info.ToolboxUrl || "",
      documents: info.Documents
        ? info.Documents.map((doc) => {
            return {
              url: doc.Url,
              description: doc.Description,
              urlType: doc.Type,
            };
          })
        : [],
      versionUrl: info.RawFileId
        ? `https://services.statescape.com/search/billversions.aspx?rid=${info.RawFileId}`
        : "",
    },
  };
}

function matchIderInfo(info) {
  return {
    textValues: {
      ider: info.IDer || "",
      iderReviewed: info.IDerReviewed || "",
      iderReviewedDate: formatDate(info.IDerReviewedDate),
    },
  };
}

function matchKeywordHits(hits) {
  return hits.map((hit) => {
    return {
      textValues: {
        team: hit.Team || "",
        client: hit.Client || "",
        grouping: hit.Subject || "",
        keyword: hit.Keyword || "",
        hits: hit.Hits,
        foundDate: formatDate(hit.FoundDate),
        changeDate: formatDate(hit.ChangeDate),
        oldHits: hit.OldHits,
        keywordId: hit.KeywordId,
        taggingInstructions: hit.GroupTaggingInstructions || "",
        description: hit.GroupDescription || "",
        overview: hit.GroupOverview || "",
        boolPhrase: hit.BoolPhrase,
        groupingId: hit.GroupingId,
        sortIdDefault: hit.SortIdDefault,
        sortIdChangedDate: hit.SortIdChangedDate,
        sortIdFoundDate: hit.SortIdFoundDate,
      },
    };
  });
}

function matchClientSubjects(clients) {
  return clients.map((client) => {
    return {
      textValues: {
        deleted: client.DeleteIt || false,
        client: client.ClientName || "",
        clientDescription: client.ClientDescription || "",
        subject: client.Subject || "",
        subjectDescription: client.SubjectDescription || "",
        changeDate: formatDate(client.CreateDate),
        user: client.CreateUserId || "",
      },
    };
  });
}

function matchQCKeywordReview(keywordsReview) {
  return keywordsReview.map((keywordReview) => {
    return {
      textValues: {
        reviewDate: formatDate(keywordReview.ReviewDate),
        reviewer: keywordReview.Reviewer || "",
        client: keywordReview.Client || "",
        subject: keywordReview.Subject || "",
      },
    };
  });
}

function matchQCKeywordMissing(keywordsMissing) {
  return keywordsMissing.map((keywordMissing) => {
    return {
      textValues: {
        client: keywordMissing.Client || "",
        subject: keywordMissing.Subject || "",
        team: keywordMissing.Team || "",
        id: keywordMissing.Id || "",
        reviewed: keywordMissing.Reviewed || "",
      },
    };
  });
}

// ------------------------------------
// Actions
// ------------------------------------

const getReviewData = (rawFileId) => {
  return (dispatch) =>
    Promise.all([
      dispatch(getRawFile(rawFileId)),
      dispatch(getLegisTeamReview(rawFileId)),
      dispatch(getLegisKeywords(rawFileId)),
      dispatch(getLegisClientSubjects(rawFileId)),
      dispatch(getQCKeywordMissing(rawFileId)),
      dispatch(getQCKeywordReview(rawFileId)),
    ]);
};

export function openReviewRecord(rawFileId) {
  return (dispatch) => {
    dispatch({ type: LEGIS_NRR_OPEN_RECORD_START });
    dispatch(getReviewData(rawFileId, dispatch)).finally(() => {
      dispatch({ type: OPEN_LEGIS_RECORD_SUCCESS, payload: { rawFileId } });
    });
  };
}

const getInitialData = () => {
  return (dispatch) => Promise.all([dispatch(getLegisNRR())]);
};

export function loadInitialData() {
  return (dispatch) =>
    Promise.all([
      dispatch({ type: GET_LEGIS_INITIAL_DATA_START }),
      dispatch(getInitialData()).finally(() => {
        dispatch({ type: GET_LEGIS_INITIAL_DATA_COMPLETE });
      }),
    ]);
}

export function getLegisNRR() {
  return (dispatch) => {
    dispatch({ type: GET_LEGIS_NRR_QUERY_DATA_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/NewRecordReview`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_LEGIS_NRR_QUERY_DATA_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LEGIS_NRR_QUERY_DATA_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        dispatch({ type: GET_LEGIS_NRR_QUERY_DATA_FAILURE, json: err.message });
      });
  };
}

export function postLegisNRR(legisUrlsParameters) {
  return (dispatch) => {
    dispatch({ type: GET_LEGIS_TEAM_REVIEW_OPTIONS_DATA_START });
    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify(legisUrlsParameters),
    };
    return fetch(`${globals.apiUrl}/NewRecordReview`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_LEGIS_TEAM_REVIEW_OPTIONS_DATA_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LEGIS_TEAM_REVIEW_OPTIONS_DATA_SUCCESS,
            payload: {
              json,
            },
          });
          if (json.result.length > 0) {
            dispatch(openReviewRecord(json.result[0]));
          } else {
            dispatch(showModal("No-results"));
            dispatch(clearFormFields());
          }
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_LEGIS_TEAM_REVIEW_OPTIONS_DATA_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getLegisTeamReview(id) {
  return (dispatch) => {
    dispatch({ type: GET_LEGIS_TEAM_REVIEW_DATA_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RawFile/TeamReview/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_LEGIS_TEAM_REVIEW_DATA_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LEGIS_TEAM_REVIEW_DATA_SUCCESS,
            payload: {
              json,
              id,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_LEGIS_TEAM_REVIEW_DATA_FAILURE,
          json: err.message,
        });
      });
  };
}

export function postLegisTeamsReview(id, teams, reviewed, flagType) {
  return (dispatch) => {
    dispatch({ type: SET_LEGIS_TEAMS_REVIEW_DATA_START });
    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({
        rawFileId: id,
        team: teams[0],
        reviewed: reviewed,
        flagType: flagType,
      }),
    };
    return fetch(`${globals.apiUrl}/RawFile/TeamReview`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: SET_LEGIS_TEAMS_REVIEW_DATA_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: SET_LEGIS_TEAMS_REVIEW_DATA_SUCCESS,
            payload: {
              json,
              id,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: SET_LEGIS_TEAMS_REVIEW_DATA_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getRawFile(id) {
  return (dispatch) => {
    dispatch({ type: GET_LEGIS_RAWFILE_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RawFile/GetRawFile/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_LEGIS_RAWFILE_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LEGIS_RAWFILE_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_LEGIS_RAWFILE_FAILURE, json: err.message });
      });
  };
}

export function postIdReviewed(id) {
  return (dispatch) => {
    dispatch({ type: SET_LEGIS_ID_REVIEWED_START });
    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: id,
    };
    return fetch(`${globals.apiUrl}/RawFile/IdReview`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: SET_LEGIS_ID_REVIEWED_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: SET_LEGIS_ID_REVIEWED_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: SET_LEGIS_ID_REVIEWED_FAILURE, json: err.message });
      });
  };
}

export function getLegisKeywords(id) {
  return (dispatch) => {
    dispatch({ type: GET_LEGIS_KEYWORDS_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RawFile/GetKeywords/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_LEGIS_KEYWORDS_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LEGIS_KEYWORDS_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_LEGIS_KEYWORDS_FAILURE, json: err.message });
      });
  };
}

export function getLegisClientSubjects(id) {
  return (dispatch) => {
    dispatch({ type: GET_LEGIS_CLIENT_SUBJECTS_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RawFile/GetClientSubjects/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_LEGIS_CLIENT_SUBJECTS_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LEGIS_CLIENT_SUBJECTS_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_LEGIS_CLIENT_SUBJECTS_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getQCKeywordReview(id) {
  return (dispatch) => {
    dispatch({ type: GET_QC_KEYWORD_REVIEW_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RawFile/GetQCKeywordReview/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_QC_KEYWORD_REVIEW_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_QC_KEYWORD_REVIEW_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_QC_KEYWORD_REVIEW_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getQCKeywordMissing(id) {
  return (dispatch) => {
    dispatch({ type: GET_QC_KEYWORD_MISSING_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RawFile/GetQCKeywordMissing/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_QC_KEYWORD_MISSING_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_QC_KEYWORD_MISSING_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_QC_KEYWORD_MISSING_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getSubjectGroupList(client, subject) {
  return (dispatch) => {
    dispatch({ type: GET_LEGIS_SUBJECT_GROUP_LIST_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/SubjectGroupList`);

    const params = {
      client,
      subject,
      searchType: "Legislation",
    };

    if (Object.keys(params)) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_LEGIS_SUBJECT_GROUP_LIST_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LEGIS_SUBJECT_GROUP_LIST_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_LEGIS_SUBJECT_GROUP_LIST_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getHighlightedDocument(teams, keywords, path) {
  return (dispatch) => {
    dispatch({ type: GET_LEGIS_HIGHLIGHTED_DOC_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/KeywordHits`);

    const params = {
      docpath: path,
      service: "legis",
    };

    if (Object.keys(params)) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    if (teams && teams.length != 0) {
      teams.forEach((team) => {
        if (String(team).length > 0) {
          url.searchParams.append("teamId", team);
        }
      });
    }

    if (keywords && keywords.length != 0) {
      keywords.forEach((keyword) =>
        url.searchParams.append("keywordId", keyword)
      );
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.url;
        } else if (response.status === 302) {
          return response.url;
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_LEGIS_HIGHLIGHTED_DOC_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((url) => {
        if (url) {
          dispatch({
            type: GET_LEGIS_HIGHLIGHTED_DOC_SUCCESS,
            payload: {
              url,
            },
          });
          return url;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_LEGIS_HIGHLIGHTED_DOC_FAILURE,
          json: "Highlighting document: " + err.message,
        });
        dispatch(showModal("Error"));
      });
  };
}

export function postQCKeywordReview(rawfileId, team, customName) {
  return (dispatch) => {
    dispatch({ type: SET_QC_KEYWORD_REVIEW_START });

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({ rawfileId, team, customName }),
    };

    return fetch(`${globals.apiUrl}/RawFile/QCKeywordReview`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: SET_QC_KEYWORD_REVIEW_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((success) => {
        return success;
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: SET_QC_KEYWORD_REVIEW_FAILURE, json: err.message });
      });
  };
}

export function postRawFileLoad(rawfileId, state) {
  return (dispatch) => {
    dispatch({ type: POST_RAW_FILE_LOAD_START });

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({ rawfileId, state }),
    };

    return fetch(`${globals.apiUrl}/RawFile/Load`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: POST_RAW_FILE_LOAD_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: POST_RAW_FILE_LOAD_SUCCESS,
            payload: {
              json,
            },
          });
          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: POST_RAW_FILE_LOAD_FAILURE, json: err.message });
      });
  };
}

export function clearFormFields() {
  return {
    type: CLEAR_LEGIS_FIELD_FOR_NO_RESULTS,
  };
}

export function returnInitialState() {
  return {
    type: RETURN_LEGIS_RECORD_REVIEW_INITIAL_STATE,
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_DATA]: (state, action) =>
    action.location.page !== pageIndex.legisNewRecordReview
      ? state
      : actionHandler(state, action),
  [RETURN_LEGIS_RECORD_REVIEW_INITIAL_STATE]: () => {
    return {
      ...initialState,
    };
  },
  [GET_LEGIS_NRR_QUERY_DATA_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_LEGIS_NRR_QUERY_DATA_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    return {
      ...state,
      renderData: {
        ...state.renderData,
        queriesWithParameters: json,
        queries: json.map((item) => {
          return {
            value: item.QueryId,
            label: item.QueryName,
          };
        }),
      },
    };
  },
  [GET_LEGIS_TEAM_REVIEW_OPTIONS_DATA_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_LEGIS_TEAM_REVIEW_OPTIONS_DATA_SUCCESS]: (state, action) => {
    const queryRecords = action.payload.json.result;
    const queryProperties = action.payload.json.props;
    return {
      ...state,
      renderData: {
        ...state.renderData,
        queryRecords,
        queryProperties,
      },
    };
  },
  [GET_LEGIS_TEAM_REVIEW_OPTIONS_DATA_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [GET_LEGIS_TEAM_REVIEW_DATA_START]: (state) => {
    return {
      ...state,
    };
  },
  [GET_LEGIS_TEAM_REVIEW_DATA_SUCCESS]: (state, action) => {
    const recordsData = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LNRR: {
          ...state.formDataValue.LNRR,
          reviewRecords: matchReviewRows(recordsData),
        },
      },
    };
  },
  [GET_LEGIS_TEAM_REVIEW_DATA_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [SET_LEGIS_TEAMS_REVIEW_DATA_START]: (state) => {
    return {
      ...state,
    };
  },
  [SET_LEGIS_TEAMS_REVIEW_DATA_SUCCESS]: (state, action) => {
    const recordsData = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LNRR: {
          ...state.formDataValue.LNRR,
          reviewRecords: matchReviewRows(recordsData),
        },
      },
    };
  },
  [SET_LEGIS_TEAMS_REVIEW_DATA_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [GET_LEGIS_QUERIES_LIST_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [POST_RAW_FILE_LOAD_START]: (state) => {
    return {
      ...state,
    };
  },
  [POST_RAW_FILE_LOAD_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [POST_RAW_FILE_LOAD_SUCCESS]: (state, action) => {
    const legisId = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LNRR: {
          ...state.formDataValue.LNRR,
          recordInfo: {
            ...state.formDataValue.LNRR.recordInfo,
            textValues: {
              ...state.formDataValue.LNRR.recordInfo.textValues,
              legisId: legisId,
            },
          },
        },
      },
    };
  },
  [GET_LEGIS_RAWFILE_START]: (state) => {
    return {
      ...state,
    };
  },
  [GET_LEGIS_RAWFILE_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [GET_LEGIS_RAWFILE_SUCCESS]: (state, action) => {
    const recordInfo = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LNRR: {
          ...state.formDataValue.LNRR,
          recordInfo: matchRecordInfo(recordInfo),
          iderReviewedInfo: matchIderInfo(recordInfo),
        },
      },
    };
  },
  [GET_LEGIS_INITIAL_DATA_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_LEGIS_INITIAL_DATA_COMPLETE]: (state) => {
    return {
      ...state,
      isFetchingData: false,
    };
  },
  [LEGIS_NRR_OPEN_RECORD_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [OPEN_LEGIS_RECORD_SUCCESS]: (state, action) => {
    const currentIndex = state.renderData.queryRecords.findIndex(
      (record) => record === action.payload.rawFileId
    );
    return {
      ...state,
      isFetchingData: false,
      formDataValue: {
        ...state.formDataValue,
        LNRR: {
          ...state.formDataValue.LNRR,
          currentRawFileId: action.payload.rawFileId,
          navigation: {
            ...state.formDataValue.LNRR.navigation,
            textValues: {
              ...state.formDataValue.LNRR.navigation.textValues,
              currentRecord: currentIndex + 1,
            },
          },
        },
      },
    };
  },
  [SET_LEGIS_ID_REVIEWED_SUCCESS]: (state, action) => {
    const iderInfo = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LNRR: {
          ...state.formDataValue.LNRR,
          iderReviewedInfo: matchIderInfo(iderInfo),
        },
      },
    };
  },
  [GET_LEGIS_KEYWORDS_SUCCESS]: (state, action) => {
    const keywordHits = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LNRR: {
          ...state.formDataValue.LNRR,
          recordKeywordHits: matchKeywordHits(keywordHits),
        },
      },
    };
  },
  [GET_LEGIS_CLIENT_SUBJECTS_SUCCESS]: (state, action) => {
    const keywordHits = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LNRR: {
          ...state.formDataValue.LNRR,
          recordClientSubjects: matchClientSubjects(keywordHits),
        },
      },
    };
  },
  [GET_QC_KEYWORD_MISSING_SUCCESS]: (state, action) => {
    const keywordsMissing = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LNRR: {
          ...state.formDataValue.LNRR,
          recordQCKeywordMissing: matchQCKeywordMissing(keywordsMissing),
        },
      },
    };
  },
  [GET_QC_KEYWORD_REVIEW_SUCCESS]: (state, action) => {
    const keywordsReview = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LNRR: {
          ...state.formDataValue.LNRR,
          recordQCKeywordReview: matchQCKeywordReview(keywordsReview),
        },
      },
    };
  },
  [GET_LEGIS_HIGHLIGHTED_DOC_START]: (state) => {
    return {
      ...state,
    };
  },
  [GET_LEGIS_HIGHLIGHTED_DOC_SUCCESS]: (state) => {
    return {
      ...state,
    };
  },
  [GET_LEGIS_HIGHLIGHTED_DOC_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [GET_LEGIS_SUBJECT_GROUP_LIST_START]: (state, action) => {
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LNRR: {
          ...state.formDataValue.LNRR,
          clientSubjectGroupings: [],
        },
      },
    };
  },
  [GET_LEGIS_SUBJECT_GROUP_LIST_SUCCESS]: (state, action) => {
    const groupingsList = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LNRR: {
          ...state.formDataValue.LNRR,
          clientSubjectGroupings: groupingsList,
        },
      },
    };
  },
  [GET_LEGIS_SUBJECT_GROUP_LIST_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [SET_QC_KEYWORD_REVIEW_START]: (state) => {
    return {
      ...state,
    };
  },
  [SET_QC_KEYWORD_REVIEW_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [CLEAR_LEGIS_FIELD_FOR_NO_RESULTS]: (state) => {
    const query = state.renderData.queriesWithParameters.find(
      (query) => query.QueryId == state.formDataValue.LNRR.queryLine.radio.query
    );

    const {
      parametersSectionSelectables,
      sortParameters,
      sortFields,
      sortDirections,
      filterFields,
    } = populateSortAndSearchParams(query);

    return {
      ...initialState,
      disableEditing: true,
      renderData: {
        ...initialState.renderData,
        queriesWithParameters: state.renderData.queriesWithParameters,
        queries: state.renderData.queries,
        allRegions: state.renderData.allRegions,
        regions: state.renderData.regions,
        regionsList: state.renderData.regionsList,
      },
      formDataValue: {
        LNRR: {
          ...initialState.formDataValue.LNRR,
          queryLine: {
            ...state.formDataValue.LNRR.queryLine,
          },
          parametersSection: {
            ...state.formDataValue.LNRR.parametersSection,
            radio: parametersSectionSelectables,
          },
          sortParameters: {
            radio: sortParameters,
            fields: sortFields,
          },
          sortDirections: {
            radio: sortDirections,
          },
          filterParameters: {
            fields: filterFields,
          },
          settingsLine: {
            ...state.formDataValue.LNRR.settingsLine,
            radio: {
              ...state.formDataValue.LNRR.settingsLine.radio,
              autoAdvance:
                state.formDataValue.LNRR.settingsLine.radio.autoAdvance,
              autoUrl: state.formDataValue.LNRR.settingsLine.radio.autoUrl,
              extraInfoExpanded:
                state.formDataValue.LNRR.settingsLine.radio.extraInfoExpanded,
            },
          },
        },
      },
    };
  },
};
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  errorCode: "",
  isFetchingData: false,
  renderData: {
    queryRecords: [],
    queryProperties: [],
    currentRecord: {},
    recordIndex: 0,
  },
  formDataValue: {
    LNRR: {
      settingsLine: {
        radio: {
          autoAdvance: true,
          autoUrl: false,
          extraInfoExpanded: false,
        },
      },
      queryLine: {
        radio: {
          query: "Select Query",
        },
        textValues: {
          keywordSearch: "",
        },
        selected: [],
      },
      parametersSection: {
        textValues: {},
        dateTime: {},
        radio: [],
      },
      sortParameters: {
        radio: [],
        fields: [],
      },
      sortDirections: {
        radio: [],
      },
      filterParameters: {
        fields: [],
      },
      navigation: {
        textValues: {
          currentRecord: "1",
        },
      },
      reviewRecords: matchReviewRows([]),
      recordInfo: matchRecordInfo({}),
      iderReviewedInfo: matchIderInfo({}),
      recordKeywordHits: matchKeywordHits([]),
      recordClientSubjects: matchClientSubjects([]),
      recordQCKeywordMissing: matchQCKeywordMissing([]),
      recordQCKeywordReview: matchQCKeywordReview([]),
      clientSubjectGroupings: [],
      otherDocs: {
        0: {
          textValues: {
            urlIdDocs: "",
            urlDescription: "",
          },
          radio: {
            docsType: "versions",
          },
        },
      },
      clients: {
        selected: [],
      },
      notLoadedClients: {
        selected: [],
      },
      history: {
        textValues: {
          history: "",
        },
      },
    },
  },
};

export default function legisNewRecordReviewReducer(
  state = initialState,
  action
) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/legisNewRecordReviewFormData.js